import { onValue, ref, remove, set, update,get,child,getDatabase } from 'firebase/database';import './App.css';
import { db } from './firebase';
import { useState,useEffect } from 'react';
import { uid } from 'uid';
import { isDisabled, isEditable } from '@testing-library/user-event/dist/utils';
function Admin() {
	const [name,setName]=useState("老師")
	const [message,setMessage]=useState("")
	const [datas,setDatas]=useState([])
    const [isEdit,setIsEdit]=useState(false)
	const [tempUuid,setTempUuid]=useState("")
	const [ip,setIp]=useState("")
    const [badge,setBadge]=useState("老師留言")
    const [response,setResponse]=useState("")
    const handleNameChange=(e)=>{
		setResponse(e.target.value)
	}
    //delete
    const handleDelete=(name)=>{
        remove(ref(db,`/${name.uuid}`))
		
	}
	//write
	const writeDB=()=>{
		const uuid=Date.now()
		const currentTime = new Date().toLocaleDateString();
		if(name!=''){
			set(ref(db,`/${uuid}`),{
				name,
				uuid,
				message,
				ip,
                badge,
				currentTime
			})
		setName("老師")
		}else{
			alert("must include data!")
		}
		
	}
    //update
	const handleUpdate=(name)=>{
        setIsEdit(true)
        setTempUuid(name.uuid)
        setResponse(name.response.replace("老師回覆：", ""))
	}
	const handleSubmitUpdate=()=>{
		update(ref(db,`/${tempUuid}`),{
            response:"老師回覆："+response,
			uuid:tempUuid,
		})
		setResponse("")
		setIsEdit(false)
	}
    
	//read
	useEffect(()=>{
		fetch('https://api.ipify.org?format=json')
		.then(response => response.json())
		.then(data => {
			var clientIP = data.ip;
			// console.log(clientIP);
			setIp(clientIP)
		});
		onValue(ref(db),(snapshot)=>{
			setDatas([])
			const data = snapshot.val()
			//console.log(data)
			if(data!==null && data !=""){
				Object.values(data).map((element)=>{
					// console.log(element)
					setDatas((oldArray)=>[...oldArray,element])
				})
			}
		})
	},[])
	return (
		<div className="App">
			<h1 className='title'>APCS 暑期營隊留言板(管理員)</h1>
            {isEdit ? (
					<>
                        <input type='text' value={response} onChange={handleNameChange}/>
						<button className='submit_btn' onClick={handleSubmitUpdate}>submit</button>
						<button className='x_btn' onClick={()=>{setIsEdit(false);setName("老師")}}>X</button>
					</>
					):(
					<>
						
					</>
					)}
			<div className='form'>
				<input type='hidden'/>
				<input className='name' type='text' placeholder='輸入姓名' defaultValue={"老師"} onChange={(e)=>{setName(e.target.value);}}disabled/>
				<br/>
				<textarea className='message'type='text' rows={10} placeholder='請輸入訊息' onChange={(e)=>{setMessage(e.target.value);}} defaultValue={""}/>
				<br/>
				<button onClick={writeDB}>送出</button>
			</div>
			<br/>
			<div className='board'>
			{datas.map((element)=>{
					return(
						// <DataView key={element.uuid} data={element.todo} uid={element.uuid}></DataView>
						<div className="dataView" key={"dataView_"+element.uuid}>
							<input hidden key={element.uuid} id={element.uuid} value={element.uuid} readOnly/>
							<div className='dataView_upper'>
                                <p className='adminBadge' key={"badge_"+element.uuid}>{element.badge}</p>
								<div className='dataView_div' key={"name_"+element.uuid}>{element.name}</div>
								<div className='dataView_div' key={"ip_"+element.uuid}>{element.ip}</div>
								<div className='message_data' key={"value_"+element.uuid}>{element.message}</div>
								<textarea className='dataView_div dataView_div_res' key={"res_"+element.uuid} disabled defaultValue={element.response} rows={5}></textarea>
                                <button className="upd_btn" key={"upd_"+element.uuid} onClick={()=>handleUpdate(element)} >回覆</button>
                                <button className="del_btn" key={"del_"+element.uuid} onClick={()=>handleDelete(element)}>刪除</button>
							</div>
							{/* <button className="upd_btn" key={"upd_"+element.uuid} onClick={()=>handleUpdate(element)} >update</button>
							<button className="del_btn" key={"del_"+element.uuid} onClick={()=>handleDelete(element)}>delete</button> */}
						</div>
					)
				})}
			</div>
		</div>
	);
}

export default Admin;
